import { Tabs } from '@components/Tabs'
import { TabBody } from '@components/Tabs/components/TabBody'
import { TabModeEnum } from '@components/Tabs/interface'
import { SearchByEnum } from '@interfaces/SearchByEnum'
import { useWindowSize } from '@hooks/useWindowSize'
import { AdvanceSearchForm } from '../../components/AdvanceSearchForm'
import { SearchPageProps } from './interface'
import { SearchResult } from './components/SearchResult'

export function SearchPage({
  books,
  initialValues,
  page,
  perpage,
  total,
  isLoading,
  showAdvanceSearch,
  isLoadingToggleBookLike,
  handleSubmit,
  handlePageChange,
  perpageChange,
  handleLikeBook,
  handleSearchBy,
  handleAdvanceSearchChange,
}: SearchPageProps) {
  const { isDesktop } = useWindowSize()
  const searchOptios = [
    {
      tabId: SearchByEnum.ALL,
      name: 'ทั้งหมด',
      dataTest: 'tab-all',
    },
    {
      tabId: SearchByEnum.TITLE,
      name: 'ชื่อเรื่อง',
      dataTest: 'tab-title',
    },
    {
      tabId: SearchByEnum.WRITER,
      name: 'ผู้แต่ง',
      dataTest: 'tab-writer',
    },
    {
      tabId: SearchByEnum.CONTENT,
      name: 'เนื้อหา',
      dataTest: 'tab-intro',
    },
    {
      tabId: SearchByEnum.TAG,
      name: 'แท็ก',
      dataTest: 'tab-tag',
    },
  ]

  return (
    <>
      <AdvanceSearchForm
        handleSubmit={handleSubmit}
        initialValues={initialValues}
        advanceSearch={showAdvanceSearch}
        handleAdvanceSearchChange={handleAdvanceSearchChange}
        isLoading={isLoading}
      />
      <Tabs
        initialTabs={searchOptios}
        mode={TabModeEnum.LINE}
        onActiveTabChange={handleSearchBy}
        isFirstTabMargin={!isDesktop}
      >
        {searchOptios.map(row => (
          <TabBody key={row.tabId} tabId={row.tabId}>
            <SearchResult
              isLoading={isLoading}
              page={page}
              books={books}
              perpage={perpage}
              total={total}
              isLoadingToggleBookLike={isLoadingToggleBookLike}
              pageChange={handlePageChange}
              perpageChange={perpageChange}
              handleLikeBook={handleLikeBook}
            />
          </TabBody>
        ))}
      </Tabs>
    </>
  )
}
